import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";

const BackButton = ({ fallback }: { fallback?: string }) => {
  const navigate = useNavigate();

  const goBack = () => {
    // react-router keeps a history index in window.history.state.idx.
    // idx > 0 means we navigated here in-app → a real "back" exists.
    // Otherwise (direct link / refresh / post-login redirect) history.back()
    // would leave the app, so fall back to a safe route.
    const idx = (window.history.state && window.history.state.idx) || 0;
    if (idx > 0) {
      navigate(-1);
    } else {
      // Default: go up one path segment (detail → its list), else dashboard.
      const parent =
        fallback ||
        window.location.pathname.replace(/\/[^/]+\/?$/, "") ||
        "/dashboard";
      navigate(parent);
    }
  };

  return (
    <button
      onClick={goBack}
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "1px solid #e0e0e0",
        background: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.background = "#f5f5f5";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = "#fff";
      }}
    >
      <IoArrowBackSharp size={20} color="#2e4a3f" />
    </button>
  );
};

export default BackButton;